var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1872 49.4092V9.14463C17.1872 6.884 19.0195 5.05168 21.2796 5.05168H38.903C38.7621 2.90012 36.9761 1.22718 34.82 1.22668H16.1796C13.9195 1.22668 12.0872 3.059 12.0872 5.31963V45.5842C12.0872 47.8444 13.9195 49.6767 16.1796 49.6767H17.1966C17.1911 49.588 17.1872 49.4989 17.1872 49.4092Z",
    fill: "#D4E1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9952 46.2651H23.0047C22.3005 46.2651 21.7297 45.6943 21.7297 44.9901C21.7297 44.2858 22.3005 43.7151 23.0047 43.7151H27.9952C28.6994 43.7151 29.2702 44.2858 29.2702 44.9901C29.2702 45.6943 28.6994 46.2651 27.9952 46.2651Z",
    fill: "#1AE5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1624 5.36795C40.1624 2.40308 37.7593 0 34.7945 0H16.2054C13.2405 0 10.8374 2.40308 10.8374 5.36795V45.632C10.8374 48.5969 13.2405 51 16.2054 51H34.7945C37.7593 51 40.1624 48.5969 40.1624 45.632V5.36795ZM13.3874 9.18H37.6124V39.015H13.3874V9.18ZM16.1795 2.55H34.8204C36.3434 2.53107 37.5935 3.75129 37.6124 5.27432V5.31964V6.63H13.3874V5.31964C13.3814 3.79611 14.6111 2.55598 16.1346 2.55H16.1795ZM34.8204 48.45H16.1795C14.626 48.45 13.3874 47.1376 13.3874 45.5842V41.565H37.6124V45.5842C37.6124 47.1376 36.3738 48.45 34.8204 48.45Z",
    fill: "#0635C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.b57c6e495304601a7913d558762dc93c.svg";
export { ForwardRef as ReactComponent };